/** An example search for the loadout optimizer. It's in its own file to prevent SearchFilter.tsx from pulling in the entire optimizer. */
export const exampleLOSearch = 'is:newgear, not:vendor, exactperk:"spirit of verity"';
